"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = exports.withConsumer = void 0;

var _addhoc = _interopRequireDefault(require("addhoc"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The custom context.
 *
 * @type {Object}
 * @public
 */
var Context = _react.default.createContext({
  onValidChange: function nope() {}
});
/**
 * Provide HOC for wrapping with a consumer.
 *
 * @param {Function} introduce The function returns a component.
 * @returns {Component} React Component wrapped.
 * @public
 */


exports.Context = Context;
var withConsumer = (0, _addhoc.default)(function (getWrappedComponent) {
  return _react.default.createElement(Context.Consumer, null, function (context) {
    return getWrappedComponent({
      context: context
    });
  });
}, 'withValidationContext');
exports.withConsumer = withConsumer;